import { Component, FC, ReactNode } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/PopupOverview.styl'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import Deferred from 'components/utils/Deferred'

type PopupOverviewProps = {
  imageSrc: string
  title: ReactNode
  subtitle: ReactNode
}

export class PopupOverview extends Component<PopupOverviewProps> {
  render () {
    const {
      imageSrc,
      title,
      subtitle,
    } = this.props

    return (
      <div className={ styles.overview }>
        <img className={ styles.image } src={ imageSrc } />
        <div className={ styles.title }>{ title }</div>
        <div className={ styles.subtitle }>{ subtitle }</div>
      </div>
    )
  }
}

const DeferredSpinner = Deferred(Spinner, 1000)

// special preloader for inserting as subtitle to avoid height change
export const PopupOverviewSubtitlePreloader: FC = () => {
  return (
    <div className={ styles.subtitleSpinner }><DeferredSpinner /></div>
  )
}
